<form [formGroup]="form">
    <div class="grid grid-cols-4 gap-x-8">
        <mat-form-field class="col-span-2">
            <mat-label>Well String</mat-label>
            <input matInput formControlName="wellStringName" />
        </mat-form-field>

        <mat-form-field class="col-span-2">
            <mat-label>Activity Type</mat-label>
            <input matInput formControlName="activity" disabled />
        </mat-form-field>

        <mat-form-field class="col-span-2">
            <mat-label>Record Date</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="recordDate" />
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <div class="col-span-2">
            <mat-label style="font-weight: 500; color: #313b4c">Record Time</mat-label>
            <input matInput class="input input-bordered w-full" type="time" formControlName="recordTime" />
        </div>

        <mat-form-field class="col-span-2">
            <mat-label>THP</mat-label>
            <input matInput type="number" formControlName="thp" />
        </mat-form-field>
    </div>

    <div class="divider mt-12 mb-6">
        <div style="color: grey;">Annulus Pressure Reading </div>
    </div>

    <div class="grid grid-cols-4 gap-x-8">
        <mat-form-field class="col-span-2">
            <mat-label>Annulus A</mat-label>
            <input matInput type="number" formControlName="annAPress" />
            <span matTextSuffix>psi</span>
        </mat-form-field>

        <mat-form-field class="col-span-2">
            <mat-label>Annulus B</mat-label>
            <input matInput type="number" formControlName="annBPress" />
            <span matTextSuffix>psi</span>
        </mat-form-field>

        <mat-form-field class="col-span-2">
            <mat-label>Annulus C</mat-label>
            <input matInput type="number" formControlName="annCPress" />
            <span matTextSuffix>psi</span>
        </mat-form-field>

        <mat-form-field class="col-span-2">
            <mat-label>Annulus D</mat-label>
            <input matInput type="number" formControlName="annDPress" />
            <span matTextSuffix>psi</span>
        </mat-form-field>

        <mat-form-field class="col-span-4 mt-12">
            <mat-label>Remarks</mat-label>
            <textarea matInput formControlName="remarks"></textarea>
        </mat-form-field>
    </div>
</form>